<template>
  <div class="layout-list">
    <div class="row">
      <div class="small-3 columns small-centered">
        <error-reveal :error="error"></error-reveal>
      </div>
    </div>
    <div class="row small-collapse">
      <div class="small-12 columns">
        <data-grid
          :items="items"
          :columns="columns"
          @additem="onAddNewItem"
          @itemaction="onItemAction"
          @refresh="onGridRefresh"
        ></data-grid>
      </div>
    </div>
    <data-store
      ref="store"
      :service="service"
      :filter="filter"
      :sort="sort"
      @beforeload="onBeforeLoad"
      @afterload="onAfterLoad"
      @dataloaded="onDataLoaded"
      @loaderror="onLoadError"
    ></data-store>
  </div>
</template>

<script>
import { mapMutations } from 'vuex'
import * as mutationTypes from '../../store/mutation-types'
import DataGrid from '../../lists/DataGrid'
import DataStore from '../../data/Store'
import ErrorReveal from '../../errors/Reveal'
import feedService from '../../services/feed'
import i18nService from '../../services/i18n'
export default {
  name: 'feeds-list',
  components: {
    DataGrid,
    DataStore,
    ErrorReveal
  },
  data () {
    return {
      items: [],
      columns: [{
        title: 'Megnevezés',
        name: 'title'
      }, {
        title: 'Stratégia',
        name: 'strategy'
      }, {
        title: 'Oldal(ak)',
        name: 'channels'
      }, {
        title: 'Poszt típusok',
        name: 'postTypes'
      }, {
        title: 'Publikálás dátuma',
        name: 'lastPublishedAt',
        width: 150,
        align: 'center'
      }, {
        actions: [{
          name: 'edit',
          html: '<i class="fi-page-edit"></i> Szerkesztés'
        }, {
          name: 'refresh',
          html: '<i class="fi-refresh"></i> Frissítés'
        }, {
          name: 'openrss',
          html: '<i class="fi-rss"></i> RSS'
        }],
        width: 230,
        align: 'center'
      }],
      service: feedService.list,
      filter: null,
      sort: null,
      error: null
    }
  },
  methods: {
    ...mapMutations([mutationTypes.BUSY_ON, mutationTypes.BUSY_OFF]),
    onAddNewItem () {
      this.$router.push({name: 'feed-edit'})
    },
    onBeforeLoad () {
      this[mutationTypes.BUSY_ON]()
    },
    onAfterLoad () {
      this[mutationTypes.BUSY_OFF]()
    },
    onDataLoaded (items, result) {
      this.items = items.map(this.parseItem)
    },
    onLoadError (error) {
      this[mutationTypes.BUSY_OFF]()
      this.error = error
    },
    onItemAction (action, item) {
      if (action.name === 'edit') {
        this.$router.push({name: 'feed-edit', params: {id: item.id}})
      }
      if (action.name === 'refresh') {
        this.onRefreshFeed(item)
      }
      if (action.name === 'openrss') {
        this.onOpenRss(item)
      }
    },
    onGridRefresh () {
      this.$refs.store.load()
    },
    onRefreshFeed (item) {
      this[mutationTypes.BUSY_ON]()
      feedService.refresh(item.id).then((data) => {
        this[mutationTypes.BUSY_OFF]()
        this.onGridRefresh()
      })
      .catch(() => {
        this[mutationTypes.BUSY_OFF]()
      })
    },
    onOpenRss (item) {
      if (item.rssUrl) {
        window.open(item.rssUrl, '_blank')
      }
    },
    parseItem (rawData) {
      return {
        id: rawData.id,
        title: rawData.title,
        strategy: this.renderStrategy(rawData.strategy),
        channels: this.renderChannels(rawData.channels),
        postTypes: this.renderPostTypes(rawData.postTypes),
        headerImage: rawData.iconUrl,
        lastPublishedAt: i18nService.formatDateTime(rawData.lastPublishedAt, i18nService.FMT_SHORT, i18nService.FMT_SHORT),
        rssUrl: rawData.rssUrl
      }
    },
    renderStrategy (strategy) {
      var labels = {
        'thresholds': 'Határértékek',
        'top': 'Top N'
      }
      return labels[strategy]
    },
    renderChannels (channels) {
      var titles = []

      if (channels) {
        titles = channels.map((channel) => channel.name)
      }
      return titles.join(', ')
    },
    renderPostTypes (postTypes) {
      var labels = {status: 'Státusz', link: 'Link', photo: 'Kép', video: 'Videó'}
      var titles = []

      if (postTypes) {
        titles = postTypes.map((v) => labels[v])
      }
      return titles.join(', ')
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
  @import '../../../sass/foundation-import';
  @import '../../../sass/layouts/list';
</style>



// WEBPACK FOOTER //
// List.vue?3bf57564